export default "__VITE_ASSET__DodZAJNT__"